import React from 'react';
import { useTranslation } from '@wix/yoshi-flow-editor';

import { ErrorSmall } from '@wix/wix-ui-icons-common/on-stage';
import { Typography } from 'wui/Typography';
import { Box } from 'wui/Box';
import { Show } from 'wui/Show';

type DurationFieldProps = {
  startDate: Date;
  endDate: Date;
  error?: string;
};

export function DurationField({
  startDate,
  endDate,
  error,
}: DurationFieldProps) {
  const { t } = useTranslation();

  const msDiff = endDate.getTime() - startDate.getTime();

  return (
    <Box direction="vertical" gap="8px">
      <Typography secondary>
        {t(
          msDiff > 0
            ? 'groups-web.event-form.fields.duration.label'
            : 'groups-web.event-form.fields.unknonw-duration.label',
          difference2Parts(msDiff),
        )}
      </Typography>
      <Show if={!!error}>
        <Typography variant="p2-14" skin="error">
          {' '}
          <ErrorSmall aria-hidden />
          {error}
        </Typography>
      </Show>
    </Box>
  );
}

function difference2Parts(milliseconds: number) {
  const mins = Math.round(((milliseconds % 86400000) % 3600000) / 60000);
  const hours = Math.floor((milliseconds % 86400000) / 3600000);
  const days = Math.floor(milliseconds / 86400000);

  return {
    days,
    mins,
    hours,
  };
}

DurationField.displayName = 'DurationField';
